<!-- @format -->

<template>
	<pc-dialog
		v-if="dialogVisible"
		v-model="dialogVisible"
		:title="title"
		:top="marginTop"
		width="700"
		@fullscreen="handleFullscreen"
		@close="closeDialog"
	>
		<el-tabs v-model="activeName" class="uploader-tab" @tab-click="onTabClick">
			<el-tab-pane v-if="!options || !options.uploadHidden" :label="'上传图片'" name="upload">
				<el-row :gutter="20">
					<el-col v-if="isHistory" :span="18">
						<ul class="uploader_ul">
							<li
								v-for="(item, index) in imagesDataList"
								:key="index"
								:class="{
									checked: selections ? selections.indexOf(item['id']) > -1 : false,
								}"
								class="uploader_tab_image"
							>
								<img
									v-if="item.id"
									:src="fileUrl(item.id)"
									style="width: 85px; height: 85px; margin-right: 10px; margin-bottom: 10px; background: #eee"
								/>
								<span class="uploader_item_status_span" @click="handleSelect(item)">
									<label class="uploader_item_status_label">
										<el-icon class="checked-status"><CircleCheckFilled /></el-icon>
									</label>
								</span>
							</li>
						</ul>
					</el-col>
					<el-col v-else :span="18">
						<ul class="uploader_ul">
							<li
								v-for="(itemFile, indexF) in fileList"
								:key="indexF"
								:class="{
									checked: selections ? selections.indexOf(itemFile['id']) > -1 : false,
								}"
								class="uploader_tab_image"
							>
								<img
									v-if="itemFile.id"
									:src="fileUrl(itemFile.id)"
									style="width: 85px; height: 85px; margin-right: 10px; margin-bottom: 10px; background: #eee"
								/>
								<span class="uploader_item_status_span" @click="handleSelect(itemFile)">
									<label class="uploader_item_status_label">
										<el-icon class="checked-status"><CircleCheckFilled /></el-icon>
									</label>
								</span>
							</li>
						</ul>
						<span v-if="$utils.isEmpty(fileList)">暂无记录</span>
						<!-- <div v-if="multiple">
							<span v-for="(itemFile, indexF) in fileList" :key="indexF" style="display: inline-block">
								<img
									v-if="itemFile.id"
									:src="fileUrl(itemFile.id)"
									style="width: 85px; height: 85px; margin-right: 10px; margin-bottom: 10px; background: #eee"
								/>
							</span>
						</div>
						<div v-else>
							<img
								v-if="fileList.id"
								:src="fileUrl(fileList.id)"
								style="width: 85px; height: 85px; margin-right: 10px; margin-bottom: 10px; background: #eee"
							/>
							<span v-if="fileList.length > 0">暂无记录</span>
						</div> -->
					</el-col>
					<el-col :span="6">
						<upload-file
							ref="upload"
							:multiple="multiple"
							:file-size="size"
							:accept="acceptRule"
							:fullscreen="fullscreen"
							:height="height"
							:init="dialogVisible"
							:limit="limit"
							:folder-alias="folderAlias"
							@callback="uploadCallback"
						/>
					</el-col>
					<el-col :span="18">
						<el-pagination
							v-model:current-page="currentPage"
							:page-size="20"
							:total="total"
							@current-change="onCurrentChange"
						/>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
		<template #footer>
			<span class="dialog-footer">
				<pc-toolbar :actions="toolbars" @action-event="handleActionEvent" />
			</span>
		</template>
	</pc-dialog>
</template>

<script>
	import { getFilePreviewUrlById } from '@power/runtime-vue3';
	import { fileTypes, allFileTypes, accept as acceptTypes } from './constants/fileTypes';
	import uploadFile from './upload';
	import { PcToolbar } from '@/components/pc-toolbar/index';
	import { getImagesFileList } from '@/api/global/index';
	import { $utils } from '@/utils/publicUtils';
	import { PcDialog } from '@/components';

	export default {
		components: {
			uploadFile,
			PcToolbar,
			PcDialog,
		},
		props: {
			value: {
				type: [String, Number, Array, Object],
			},
			multiple: {
				type: Boolean,
				default: false,
			},
			visible: {
				type: Boolean,
				default: false,
			},
			title: {
				type: String,
				default() {
					return '文件上传';
				},
			},
			marginTop: {
				type: String,
				default: '15vh',
			},
			height: {
				type: String,
				default: '240px',
			},
			fileSize: [Number, String],
			limit: {
				type: Number,
			},
			accept: {
				type: String,
				default: '',
			},
			fileExt: {
				type: Array,
				default: () => [],
			},
			options: {
				type: Object,
				default: () => {},
			},
			folderAlias: {
				type: String,
				default: '',
			},
			isHistory: {
				type: Boolean,
				default: true,
			}, //是否显示历史
			isMy: {
				type: String,
				default: 'N',
			}, //是否显示自己的上传记录
		},
		data() {
			return {
				fullscreen: false,
				dialogVisible: this.visible,
				activeName: 'upload',
				buttonKey: 'confirm',
				onlineLoad: false,
				format: true,

				fileTypes,
				allFileTypes,
				acceptTypes,
				size: null,
				targetExt: false,
				acceptRule: '',
				uploadFileList: [],
				fileList: [],
				currentPage: 1,
				total: 0,

				toolbars: [
					{ key: 'save', type: 'primary', size: 'default' },
					{ key: 'cancel', size: 'default' },
					// {
					// 	key: 'clear',
					// 	label: '清空',
					// 	size: 'default',
					// 	hidden: () => {
					// 		if (this.activeName === 'upload') return false;
					// 		return true;
					// 	},
					// },
				],
				imagesDataList: [],
				selections: [],
				$utils,
			};
		},
		watch: {
			visible: {
				handler(val) {
					this.dialogVisible = val;
					this.activeName = 'upload';
					this.uploadFileList = [];
					if (this.isHistory) {
						this.getImagesFileListMain();
					}
				},
				immediate: true,
			},
			accept: {
				handler(val) {
					if (val === '*' && this.fileExt.length !== 0) {
						const str = `.${this.fileExt.join(',').replace(/,/g, ',.')}`;
						this.acceptRule = str;
					} else {
						this.acceptRule = val;
					}
				},
				immediate: true,
			},
			fileSize: {
				handler(val) {
					if ($utils.isNotEmpty(val)) {
						this.size = typeof val === 'number' ? val * 1024 * 1024 : parseFloat(val) * 1024 * 1024;
					}
				},
				immediate: true,
			},
		},
		beforeUnmount() {
			this.fileTypes = null;
			this.allFileTypes = null;
			this.acceptTypes = null;
			this.uploadFileList = null;
			this.fileList = null;
			this.toolbars = null;
		},
		methods: {
			handleFullscreen(val) {
				this.fullscreen = val;
			},
			handleActionEvent({ key }) {
				switch (key) {
					case 'save':
						this.handleConfirm();
						break;
					case 'cancel':
						this.closeDialog();
						break;
					case 'clear':
						this.handleClearFiles();
						break;
					default:
						break;
				}
			},
			handleClearFiles() {
				this.uploadFileList = [];
				this.$refs['upload'].clearFiles();
			},
			uploadCallback(data) {
				this.uploadFileList = data;
				if (this.multiple) {
					this.fileList = $utils.isNotEmpty(this.value) ? [...this.value, ...this.uploadFileList] : this.uploadFileList;
				} else {
					this.fileList.push(this.uploadFileList);
				}
				if (this.isHistory) {
					this.getImagesFileListMain();
				}
			},
			// 关闭当前窗口
			closeDialog() {
				this.uploadFileList = [];
				this.$emit('close', false);
			},
			onTabClick(tab) {
				if (tab.name === 'online') {
					this.onlineLoad = !this.onlineLoad;
				}
			},
			onFormat(format) {
				this.format = format;
			},
			/**
			 * 文件类型的限制
			 */
			// fileExtType() {
			// 	const accept = this.accept;
			// 	const acceptTypes = this.acceptTypes;
			// 	const fileTypes = this.fileTypes;
			// 	let type = '';
			// 	let targetFileTypes = [];
			// 	this.targetExt = false;
			// 	for (const i in acceptTypes) {
			// 		if (acceptTypes[i] === accept) {
			// 			type = i;
			// 			targetFileTypes = fileTypes[i];
			// 		} else {
			// 			if (accept === '*') {
			// 				// 不限制
			// 				targetFileTypes = '*';
			// 			} else {
			// 				// 自定义
			// 				targetFileTypes = accept.split(',');
			// 			}
			// 		}
			// 	}
			// 	const fileList = this.multiple ? this.fileList : [this.fileList];
			// 	if (targetFileTypes !== '*') {
			// 		this.targetExt = fileList.every((i) => {
			// 			if (type === 'compress') {
			// 				return targetFileTypes.includes(`${i.resourceExtend}`);
			// 			} else {
			// 				return targetFileTypes.includes(`.${i.resourceExtend}`);
			// 			}
			// 		});
			// 	} else {
			// 		this.targetExt = true;
			// 	}
			// 	return this.targetExt;
			// },
			handleConfirm() {
				if (!this.multiple) {
					if ($utils.isNotEmpty(this.selections) && this.selections.length > 1) {
						this.$message.closeAll();
						this.$message({
							message: '附件上传设置为单选，选择文件数量只能为1个',
							type: 'warning',
						});
						return;
					}
				}

				if ($utils.isNotEmpty(this.limit) && this.limit < this.selections.length) {
					this.$message.closeAll();
					this.$message({
						message: `超过设置最大上传数量限制${this.limit}张`,
						type: 'warning',
					});
					return;
				}
				this.$emit('action-event', this.buttonKey, this.selections);
			},
			getImagesFileListMain() {
				const obj = {
					folderAlias: this.folderAlias,
					groupKey: '',
					isMy: this.isMy,
					fileType: '',
					fileSize: '',
					pageNo: this.currentPage,
					limit: 20,
				};

				getImagesFileList(obj)
					.then((response) => {
						this.imagesDataList = response.rows;
						this.total = response.total;
					})
					.catch(() => {});
			},
			onCurrentChange() {
				this.getImagesFileListMain();
			},
			fileUrl(fileId) {
				return getFilePreviewUrlById(fileId);
			},
			handleSelect(row) {
				const selection = row['id'];
				const index = this.selections.indexOf(selection);
				if (index === -1) {
					if (this.multiple) {
						this.selections.push(selection);
					} else {
						this.selections = [selection];
					}
				} else {
					this.selections.splice(index, 1);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.uploader_ul {
		list-style: none;
	}

	.uploader_tab_image {
		position: relative;
		float: left;

		.uploader_item_status_span {
			position: absolute;
			right: 10px;
			width: 85px;
			height: 85px;
		}

		.uploader_item_status_label {
			display: none;
			position: absolute;
			right: 10px;
			top: 10px;
			width: 16px;
			height: 16px;
			border: 1px solid #dfe6ec;
			border-radius: 50%;
			text-align: center;
			color: #fff;
			background: #fff;

			i {
				display: none;
				color: #409eff;
				font-size: 18px;
				top: -4px;
				left: -2px;
				border-radius: 50%;
			}
		}

		:hover .uploader_item_status_label {
			display: block;
		}
	}

	.checked .uploader_item_status_label {
		display: block;
	}

	.checked .uploader_item_status_label i.checked-status {
		display: block;
	}
</style>
